module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_8003.db5d2601.png";